'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { FAKE_REFEREES, USE_FAKE_REFERRAL_DATA } from '@/components/portfolio/referrals/_fake-data';
import { RefereeList } from '@/components/portfolio/referrals/referee-list';
import { SilkSheet } from '@/components/ui/silk-sheet';
interface ShowRefereesDialogProps {
  userId: string;
  count: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export function ShowRefereesDialog(t0) {
  const $ = _c(11);
  const {
    userId,
    count,
    open,
    onOpenChange
  } = t0;
  const t = useTranslations("profile.next.summary.referrals");
  let t1;
  if ($[0] !== count || $[1] !== t) {
    t1 = t("sheet_title", {
      count
    });
    $[0] = count;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = USE_FAKE_REFERRAL_DATA ? {
      injectedReferees: FAKE_REFEREES
    } : {};
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== userId) {
    t3 = <RefereeList userId={userId} rowVariant="compact" hideHeader={true} {...t2} />;
    $[4] = userId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onOpenChange || $[7] !== open || $[8] !== t1 || $[9] !== t3) {
    t4 = <SilkSheet open={open} onOpenChange={onOpenChange} variant="detached" size="md" title={t1}>{t3}</SilkSheet>;
    $[6] = onOpenChange;
    $[7] = open;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}